module.exports = __webpack_public_path__ + "img/borchia_8.2f6124ca.svg";